// 시맨틱 필 (시안 .pill) — radius 5 · 10.5/800. props: tone:'ok'|'blue'|'warn'|'danger'|'gray', children, title
// 색 = fg + 9% 틴트 배경 + 30% 틴트 보더 (시안 color-mix 재현). 상태 필은 StatusPill.
import React from 'react';
import { T, FONT, tint } from '../theme';

var TONE = { ok: T.ok, blue: T.accentPress, warn: T.warn, danger: T.danger, gray: T.muted };

export function pillStyle(c) {
  return { display: 'inline-flex', alignItems: 'center', height: 20, padding: '0 8px', borderRadius: 5, fontSize: FONT.badge, fontWeight: 800,
    letterSpacing: '.1px', whiteSpace: 'nowrap', color: c, background: tint(c, 0.09), border: '1px solid ' + tint(c, 0.3), boxSizing: 'border-box' };
}

function Pill(props) {
  var c = TONE[props.tone] || T.muted;
  return <span className={'v2-pill' + (props.tone ? ' ' + props.tone : '')} title={props.title} style={pillStyle(c)}>{props.children}</span>;
}

export default Pill;
